import axios from 'axios';
import { store } from '../store/store';

const edmApiBaseUrl = process.env.REACT_APP_API_URL
const edmLocalHostApiBaseUrl = process.env.REACT_APP_LOCALHOST_API_URL;
const ataccamaBaseUrl = process.env.REACT_APP_ATACCAMA_BASEURL;
const ataccamaUsername = process.env.REACT_APP_ATACCAMA_USERNAME;
const ataccamaPassword = process.env.REACT_APP_ATACCAMA_PASSWORD;


const axiosInstance = axios.create({
  baseURL: edmApiBaseUrl,
  withCredentials: true,
});

export const axiosHeartbeatInstance = async () => {
  try {
    console.log('Starting Heartbeat Check...');

    const ataccamaUsername = process.env.REACT_APP_ATACCAMA_USERNAME;
    const ataccamaPassword = process.env.REACT_APP_ATACCAMA_PASSWORD;
    const ataccamaAuth = btoa(`${ataccamaUsername}:${ataccamaPassword}`);
    let ataccamaStatus = ''


    const getAllUsersPayload = JSON.stringify({
      query: `query GetPersons($draft_persons_skip: Int, $draft_persons_size: Int, $gid: GID!) {
  userManagement(gid: $gid) {
    draftVersion {
      persons(skip: $draft_persons_skip, size: $draft_persons_size) {
        edges {
          node {
            storedVersion {
              userId
              username
              firstName
              lastName
              email
              numericalIdentifier
              disabledSince
              _displayName
              _draftType
              _from {
                id
                timestamp
                author {
                  numericalIdentifier
                  ... on Person {
                    username
                    firstName
                    lastName
                    email
                    userId
                    __typename
                  }
                  ... on Service {
                    module
                    instanceId
                    __typename
                  }
                  __typename
                }
                __typename
              }
              _to {
                id
                timestamp
                __typename
              }
              __typename
            }
            operationsPermissions {
              _operations {
                operation
                __typename
              }
              userId {
                operation
                __typename
              }
              username {
                operation
                __typename
              }
              firstName {
                operation
                __typename
              }
              lastName {
                operation
                __typename
              }
              email {
                operation
                __typename
              }
              numericalIdentifier {
                operation
                __typename
              }
              disabledSince {
                operation
                __typename
              }
              __typename
            }
            hasDeepDraft
            hasComplexWorkflow
            gid
            nodePath
            parentNodePath
            parentGid
            __typename
          }
          __typename
        }
        pageInfo {
          hasNextPage
          endCursor
          __typename
        }
        totalCount
        __typename
      }
      _displayName
      _draftType
      _from {
        id
        timestamp
        author {
          numericalIdentifier
          ... on Person {
            username
            firstName
            lastName
            email
            userId
            __typename
          }
          ... on Service {
            module
            instanceId
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    operationsPermissions {
      _operations {
        operation
        __typename
      }
      persons {
        _operations {
          operation
          __typename
        }
        _virtualNodeOperations {
          operation
          __typename
        }
        userId {
          operation
          __typename
        }
        username {
          operation
          __typename
        }
        firstName {
          operation
          __typename
        }
        lastName {
          operation
          __typename
        }
        email {
          operation
          __typename
        }
        roles {
          _operations {
            operation
            __typename
          }
          _virtualNodeOperations {
            operation
            __typename
          }
          role {
            operation
            __typename
          }
          displayName {
            operation
            __typename
          }
          __typename
        }
        numericalIdentifier {
          operation
          __typename
        }
        disabledSince {
          operation
          __typename
        }
        __typename
      }
      __typename
    }
    gid
    nodePath
    parentNodePath
    parentGid
    __typename
  }
}`,
      variables: {
        draft_persons_size: 1000,
        gid: "00000000-0000-0000-0000-000000000003",
        draft_persons_skip: 0
      }
    });

    const ataccamaResponse = await axios.post(ataccamaBaseUrl, getAllUsersPayload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Basic ${ataccamaAuth}`
      }
    });

    console.log('Ataccama Response Status:', ataccamaResponse);


    if (ataccamaResponse.status !== 200) {
      console.log('Ataccama Status Failing:', ataccamaResponse.status);
      ataccamaStatus = 'Failure'
    } else {
      console.log('Ataccama Status Passing:', ataccamaResponse.status);
      ataccamaStatus = 'Operational'
    }

    const getReltioToken = async () => {
      const reltioAuth = 'https://auth.reltio.com/oauth/token?grant_type=client_credentials&client_id=svc_lennar_mdm_intg&client_secret=GyFW2t$TCvIhW8!4DJHfXTA7c8HTU6WK'
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',

      }
      const authTokenEndpoint = await axios.get(reltioAuth)


      return authTokenEndpoint.data.access_token;

    }

    let reltioStatusDescription = ''
    const getReltioStatus = async () => {
      // ENDPOINTS TO CHECK
      // HEAVY OPERATIONS
      const reltioToken = await getReltioToken();

      if (reltioToken) {
        const reltioStatus = await axios.get('https://status.snowflake.com/api/v2/summary.json');
        reltioStatusDescription = reltioStatus.data.status.description || "Unable to get status";
        console.log('RELTIO STATUS:', reltioStatusDescription)



      }


      try {
        const heavyOperations = await axios.get('https://361.reltio.com/nui/reltioAPI/api/m5SVsHpJU1CDJLZ/monitoring/heavyOperations', {
          headers: {
            'Authorization': `Bearer ${reltioToken}`,
            'Access-Control-Allow-Origin': '*'
          }
        });

        console.log('HEAVY OPERATIONS:', heavyOperations.status);
      } catch (error) {
        if (error.response) {

          console.error('Error response:', error.response.status, error.response.data);
        } else if (error.request) {

          console.error('Error request:', error.request);
        } else {

          console.error('Error message:', error.message);
        }
        console.error('Error config:', error.config);
      }
      try {
        // // INTERACTIONS API
        const interactionsApi = await axios.get('https://361.reltio.com/nui/reltioAPI/api/m5SVsHpJU1CDJLZ/interactions/_total', {
          headers: {
            'Authorization': `Bearer ${reltioToken}`
          }
        });
        console.log('INTERACTIONS API:', interactionsApi.status);
      } catch (error) {
        if (error.response) {


          console.error('Error response:', error.response.status, error.response.data);
        } else if (error.request) {

          console.error('Error request:', error.request);
        } else {

          console.error('Error message:', error.message);
        }
        console.error('Error config:', error.config);
      }

      return reltioStatusDescription
    }

    const reltioHeartbeatCheck = getReltioStatus()
    console.log('RELTIO HEARTBEAT CHECK:', reltioHeartbeatCheck)


    // prefect statuses
    const service1Response = await axios.get('https://2266113422411059.hostedstatus.com/1.0/status/5f33ff702715c204c20d6da1');
    const prefectStatus = service1Response.data.result.status_overall.status || "Unable to get status";
    console.log('PREFECT OVERALL STATUS:', prefectStatus);

    const prefectCloudAutomationStatus = service1Response.data.result.status[1].status || "Unable to get status";
    console.log('PREFECT CLOUD AUTOMATION STATUS:', prefectCloudAutomationStatus);

    const githubResponse = await axios.get('https://www.githubstatus.com/api/v2/summary.json');
    const githubStatus = githubResponse.data.status.description || "Unable to get status";
    console.log('GitHub Status:', githubStatus);

    const snowflakeResponse = await axios.get('https://status.snowflake.com/api/v2/summary.json');
    console.log('Snowflake Response:', snowflakeResponse.status);
    const snowflakeStatus = snowflakeResponse.data.status.description || "Unable to get status";
    console.log('Snowflake Status:', snowflakeStatus);


    // const azureResponse = await axios.get('https://azure.status.microsoft/en-us/status');
    const azureResponse = await axios.get('https://status.snowflake.com/api/v2/summary.json');
    console.log('%c Azure Response: %c' + azureResponse.status, 'color: white; background-color: blue; font-weight: bold;', 'color: blue; background-color: white; font-weight: bold;');
    const azureStatus = azureResponse.data.status.description || "Unable to get status";
    console.log('Azure Status:', azureStatus);

    // const powerBiResponse = await axios.get('https://powerbi.status.microsoft/en-us/status');
    const powerBiResponse = await axios.get('https://status.snowflake.com/api/v2/summary.json');
    console.log('%c Power BI Response: %c' + powerBiResponse.status, 'color: white; background-color: blue; font-weight: bold;', 'color: blue; background-color: white; font-weight: bold;');
    const powerBiStatus = powerBiResponse.data.status.description || "Unable to get status";
    console.log('Power BI Status:', powerBiStatus);


    // const awsResponse = await axios.get('https://status.aws.amazon.com/');
    const awsResponse = await axios.get('https://status.snowflake.com/api/v2/summary.json');
    console.log('%c AWS Response: %c' + awsResponse.status, 'color: white; background-color: blue; font-weight: bold;', 'color: blue; background-color: white; font-weight: bold;');
    const awsStatus = awsResponse.data.status.description || "Unable to get status";
    console.log('AWS Status:', awsStatus);




    const serviceNowResponse = await axios.get('https://status.snowflake.com/api/v2/summary.json');
    console.log('%c Service Now Response: %c' + serviceNowResponse.status, 'color: white; background-color: blue; font-weight: bold;', 'color: blue; background-color: white; font-weight: bold;');
    const serviceNowStatus = serviceNowResponse.data.status.description || "Unable to get status";
    console.log('Service Now Status:', serviceNowStatus);


    // const dbtResponse = await axios.get('https://status.getdbt.com/');
    // console.log('sdfjslfjdskljfl')
    // console.log('dbtResponse', dbtResponse)
    let dbtStatus = ''
    if (dbtStatus !== 200) {

      dbtStatus = 'Failure'
      console.log('DBT Status Failing:', dbtStatus);
    } else {

      dbtStatus = 'Operational'
      console.log('DBT Status Passing:', dbtStatus);
    }
    
    const workdayResponse = await axios.get('https://status.snowflake.com/api/v2/summary.json');
    const workdayStatus = workdayResponse.data.status.description || "Unable to get status";
    console.log('Workday Status:', workdayStatus);

    const slackResponse = await axios.get('https://slack-status.com/api/v2.0.0/current');
    console.log('%c Slack Response: %c' + slackResponse.status, 'color: white; background-color: blue; font-weight: bold;', 'color: blue; background-color: white; font-weight: bold;');
    let slackStatus = slackResponse.data.status || "Unable to get status";
    if (slackStatus === 'ok') {
      slackStatus = 'Operational'
    }
    console.log('Slack Status:', slackStatus);

    const confluenceResponse = await axios.get('https://status.snowflake.com/api/v2/summary.json');
    const confluenceStatus = confluenceResponse.data.status.description || "Unable to get status";
    console.log('Confluence Status:', confluenceStatus);

    const lucidResponse = await axios.get('https://status.snowflake.com/api/v2/summary.json');
    console.log('%c Lucid Response: %c' + lucidResponse.status, 'color: white; background-color: blue; font-weight: bold;', 'color: blue; background-color: white; font-weight: bold;');
    const lucidStatus = lucidResponse.data.status.description || "Unable to get status";
    console.log('Lucid Status:', lucidStatus);

    const snykResponse = await axios.get('https://status.snyk.io/');
    console.log('%c Snyk Response: %c' + snykResponse.status, 'color: white; background-color: blue; font-weight: bold;', 'color: blue; background-color: white; font-weight: bold;');
    let snykStatus = ''
    if (snykResponse.status !== 200) {

      snykStatus = 'Failure'
      console.log('Snyk Status Failing:', snykStatus);
    } else {
      snykStatus = 'Operational'
      console.log('Snyk Status Passing:', snykStatus);
    }

    const buildProResponse = await axios.get('https://status.snowflake.com/api/v2/summary.json');
    console.log('%c Build Pro Response: %c' + buildProResponse.status, 'color: white; background-color: blue; font-weight: bold;', 'color: blue; background-color: white; font-weight: bold;');
    const buildProStatus = buildProResponse.data.status.description || "Unable to get status";
    console.log('BuildPro Status:', buildProStatus);


    const status = [
      { name: 'ataccama', status: ataccamaStatus, url: 'https://www.ataccama.com/', icon: <i className="fa-solid fa-database"></i> },
      { name: 'snowflake', status: snowflakeStatus, url: 'https://status.snowflake.com/', icon: <i className="fa-solid fa-snowflake"></i> },
      { name: 'github', status: githubStatus, url: 'https://www.githubstatus.com/', icon: <i className="fa-brands fa-github"></i> },
      { name: 'reltio', status: reltioStatusDescription, url: 'https://www.reltio.com/', icon: <i className="fa-solid fa-tools"></i> },
      { name: 'azure', status: azureStatus, url: 'https://status.azure.com/', icon: <i className="fa-brands fa-microsoft"></i> },
      { name: 'aws', status: awsStatus, url: 'https://status.aws.amazon.com/', icon: <i className="fa-brands fa-aws"></i> },
      { name: 'powerBi', status: powerBiStatus, url: 'https://powerbi.microsoft.com/en-us/support/', icon: <i className="fa-brands fa-microsoft"></i> },
      { name: 'prefect', status: prefectStatus, url: 'https://2266113422411059.hostedstatus.com/1.0/status/5f33ff702715c204c20d6da1', icon: <i className="la la-users"></i> },
      { name: 'prefectCloud', status: prefectCloudAutomationStatus, url: 'https://2266113422411059.hostedstatus.com/1.0/status/5f33ff702715c204c20d6da1', icon: <i className="la la-users"></i> },
      { name: 'serviceNow', status: serviceNowStatus, url: 'https://servicenow.com/', icon: <i className="fa-solid fa-ticket-alt"></i> },
      { name: 'dbt', status: dbtStatus, url: 'https://status.getdbt.com/', icon: <i className="fa-solid fa-code"></i> },
      { name: 'workday', status: workdayStatus, url: 'https://www.workday.com', icon: <i className="fa-solid fa-briefcase"></i> },
      { name: 'slack', status: slackStatus, url: 'https://status.slack.com/', icon: <i className="fa-brands fa-slack"></i> },
      { name: 'confluence', status: confluenceStatus, url: 'https://status.atlassian.com/', icon: <i className="fa-solid fa-book"></i> },
      { name: 'lucid', status: lucidStatus, url: 'https://lucid.com', icon: <i className="fa-solid fa-lightbulb"></i> },
      { name: 'snyk', status: snykStatus, url: 'https://status.snyk.io/', icon: <i className="fa-solid fa-shield-alt"></i> },
      { name: 'buildPro', status: buildProStatus, url: 'https://www.buildpro.com/', icon: <i className="fa-solid fa-tools"></i> },
    ];
    console.log('Service Statuses:', status);

    const isOperational = Object.values(status).every(statusValue =>
      typeof statusValue === 'string' && statusValue.toLowerCase().includes('operational')
    );

    return {
      status,

    };
  } catch (error) {
    console.error('Error in axiosHeartbeatInstance:', error);
    return {
      status: null,
      isOperational: false,
      error: error.message
    };
  }
};

export const axiosHeartbeatInstanceNew = async () => {
  console.log(">> HEARTBEAT CHECK PRD");
  console.log(">> REACT_APP_HEARTBEAT_URL:", process.env.REACT_APP_HEARTBEAT_URL);

  const heartbeatRoute = `${process.env.REACT_APP_HEARTBEAT_URL}`;
  console.log(">> Constructed heartbeatRoute:", heartbeatRoute);
  return axiosInstance.get(heartbeatRoute)
      .then(response => {
          console.log(">> Received response from heartbeat!!:", response.data.heartbeat);
          return response.data.heartbeat;
      })
      .catch(error => {
          console.error("!! Error fetching heartbeat:", error);
          throw error;
      });
};

export default axiosInstance;
